
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-660 -624)"}},[_c('circle',{attrs:{"cx":"30","cy":"30","r":"30","transform":"translate(660 624)","fill":"#eaeaea"}}),_c('path',{attrs:{"d":"M690 638.162a15.73 15.73 0 0111.162 4.648l3.273-3.273 1.4 9.689-9.813-1.275 3.285-3.289a13.193 13.193 0 102.426 15.348l2.266 1.381A15.836 15.836 0 11690 638.162z"}})])])
          )
        }
      }
    